import { Link } from "react-router-dom";
import { levels } from "@/data/content";
import PageShell from "@/components/feature/PageShell";
import SiteCTA from "@/components/feature/SiteCTA";
import Reveal from "@/components/base/Reveal";

export default function Siniflar() {
  const crumbs = [{ label: "Ana Sayfa", href: "/" }, { label: "Sınıflar" }];

  return (
    <PageShell crumbs={crumbs}>
      {/* Hero */}
      <section className="bg-background-100 px-4 md:px-6 lg:px-10 py-14 md:py-20 border-b border-background-200">
        <div className="max-w-6xl mx-auto">
          <Reveal>
            <span className="inline-flex items-center gap-2.5 text-xs font-semibold uppercase tracking-[0.14em] text-primary-700">
              <span className="w-5 h-px bg-accent-500" aria-hidden="true"></span>
              Sınıflar
            </span>
            <h1 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-foreground-950 leading-tight max-w-2xl">
              Nereye hazırlanıyorsan, oradan başla
            </h1>
            <p className="mt-5 text-base md:text-lg text-foreground-600 leading-relaxed max-w-2xl">
              Okul öncesinden liseye; her seviyenin kendine özgü bir dünyası, ders alanları ve
              çalışma biçimi var. Seninkini seç, kişisel rotanı kur.
            </p>
          </Reveal>
        </div>
      </section>

      {/* Seviye kartları */}
      <section className="bg-background-50 px-4 md:px-6 lg:px-10 py-14 md:py-20">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {levels.map((level, i) => (
              <Reveal key={level.slug} delay={i * 60}>
                <Link
                  to={`/siniflar/${level.slug}`}
                  className="group flex flex-col h-full rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition-colors"
                >
                  <div className="relative h-44 md:h-52 overflow-hidden bg-background-100">
                    <img
                      src={level.heroImage}
                      alt={`${level.name} öğrenme dünyası`}
                      title={`${level.name} ${level.title}`}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-6 md:p-7 flex flex-col flex-1">
                    <span className="text-xs font-semibold uppercase tracking-wide text-primary-700">
                      {level.shortName}
                    </span>
                    <h2 className="mt-2.5 font-heading font-semibold text-lg md:text-xl text-foreground-950">
                      {level.title}
                    </h2>
                    <p className="mt-2 text-sm md:text-base text-foreground-600 leading-relaxed flex-1">
                      {level.subtitle}
                    </p>
                    <span className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-foreground-700 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                      {level.name} detayını incele
                      <i className="ri-arrow-right-line" aria-hidden="true"></i>
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <SiteCTA />
    </PageShell>
  );
}